<template>
	<div>
		<layout-1
			:table_name="'Job Orders'"
			:id=pageid2
			:searchbar=true
			:termchange=true
			:button_name="'Add'"
			:button_perm="'72'"
			v-on:select="selectJobOrder"
			style="width:63%; height:calc(100vh - 90px); float:left">
		</layout-1>
		<div>
			<layout-3
				:id=pageid4
				:term=term
				:width=3
				:height=2
				style="width:35%; max-height:30vh; float:right;">
			</layout-3>
			<layout-1
				:key="updateKey"
				:table_name="'PO Number Job Orders'"
				:id=pageid3
				:term=term
				:termchange=true
				:button_name="'Remove'"
				:button_perm="'72'"
				v-on:select="removeJobOrder"
				style="width:36%; height:calc(100vh - 90px - 30vh); float:right;">
			</layout-1>
		</div style="float:right">

		<div class="nav-bar">
			<div>
				<button v-on:click="back()">Done</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid1:PAGES.EDIT_PO_NUMBER_JOB_ORDERS_PAGE,
			pageid2:PAGES.JOB_ORDERS_PAGE,
			pageid3:PAGES.PO_JOBORDER_PAGE,
			pageid4:PAGES.EDIT_PO_NUMBERS_PAGE,
			updateKey:0,
		}
	},
	methods:{
		removeJobOrder (value){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid1,
						data:[value[0], this.term],
						add:false,
					}
				}
			).then((res) => {
				this.updateKey++;
			});
		},
		selectJobOrder(value){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid1,
						data:[value[0], this.term],
						add:true,
					}
				}
			).then((res) => {
				this.updateKey++;
			});
		},
		back(){
			router.go(-1);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/edit/Edit_PO_Number_Job_Orders.vue